(() => {
  const root = document.documentElement;
  let viewportFrame;
  const updateViewport = () => {
    cancelAnimationFrame(viewportFrame);
    viewportFrame = requestAnimationFrame(() => {
      const viewport = window.visualViewport;
      root.style.setProperty('--prima-viewport-height', `${viewport ? viewport.height : window.innerHeight}px`);
      root.style.setProperty('--prima-viewport-top', `${viewport ? viewport.offsetTop : 0}px`);
    });
  };
  updateViewport();
  window.addEventListener('resize', updateViewport, { passive: true });
  window.visualViewport?.addEventListener('resize', updateViewport, { passive: true });
  window.visualViewport?.addEventListener('scroll', updateViewport, { passive: true });

  const dialog = document.querySelector('[data-prima-quiz-dialog]');
  const content = dialog?.querySelector('[data-prima-quiz-content]');
  const status = dialog?.querySelector('[data-prima-quiz-status]');
  const quizCache = new Map();
  const quizRequests = new Map();
  const loadingText = status?.textContent;
  const quizUrl = link => {
    if (!link || link.hasAttribute('data-prima-quiz-fallback')) return null;
    const url = new URL(link.href, location.href);
    return url.origin === location.origin && /\/pages\/(mattress-quiz|scent-quiz)\/?$/.test(url.pathname) ? url : null;
  };
  const fetchQuiz = url => {
    if (quizRequests.has(url.pathname)) return quizRequests.get(url.pathname);
    const request = (async () => {
      const kind = url.pathname.includes('mattress-quiz') ? 'mattress' : 'scent';
      const sectionId = dialog.dataset[`${kind}Section`];
      const sectionUrl = new URL(url.href);
      if (sectionId) sectionUrl.searchParams.set('section_id', sectionId);
      const options = { credentials: 'same-origin', priority: 'low' };
      let response = await fetch(sectionUrl.href, options);
      let html = response.ok ? await response.text() : '';
      if (!html.includes(`section-nnom-${kind}-finder`) && sectionId) {
        response = await fetch(url.href, options);
        html = response.ok ? await response.text() : '';
      }
      if (!html.includes(`section-nnom-${kind}-finder`)) throw new Error('Quiz unavailable');
      return html;
    })();
    quizRequests.set(url.pathname, request);
    request.catch(() => quizRequests.delete(url.pathname));
    return request;
  };
  let requestSequence = 0;
  if (dialog) document.querySelector('#MainContent')?.append(dialog);
  let trigger;
  let savedScroll = 0;
  let oldBodyPosition = '';
  let oldBodyTop = '';
  let oldBodyWidth = '';
  let locked = false;
  const syncScrollLock = () => {
    const shouldLock = !!dialog?.open || !!document.querySelector('cart-drawer.active');
    if (shouldLock === locked) return;
    locked = shouldLock;
    root.classList.toggle('prima-overlay-open', locked);
    if (locked) {
      savedScroll = window.scrollY;
      oldBodyPosition = document.body.style.position;
      oldBodyTop = document.body.style.top;
      oldBodyWidth = document.body.style.width;
      document.body.style.position = 'fixed';
      document.body.style.top = `-${savedScroll}px`;
      document.body.style.width = '100%';
    } else {
      document.body.style.position = oldBodyPosition;
      document.body.style.top = oldBodyTop;
      document.body.style.width = oldBodyWidth;
      window.scrollTo({ top: savedScroll, behavior: 'instant' });
    }
  };
  const drawer = document.querySelector('cart-drawer');
  if (drawer) new MutationObserver(syncScrollLock).observe(drawer, { attributes: true, attributeFilter: ['class'] });

  const loadQuiz = async url => {
    const sequence = ++requestSequence;
    content.replaceChildren();
    status.textContent = loadingText;
    status.hidden = false;
    content.setAttribute('aria-busy', 'true');
    try {
      let section = quizCache.get(url.pathname);
      let scripts = [];
      if (!section) {
        const page = new DOMParser().parseFromString(await fetchQuiz(url), 'text/html');
        const selector = url.pathname.includes('mattress-quiz') ? '.section-nnom-mattress-finder' : '.section-nnom-scent-finder';
        section = page.querySelector(selector);
        if (!section) throw new Error('Quiz section unavailable');
        scripts = [...section.querySelectorAll('script')];
        scripts.forEach(script => script.remove());
      }
      if (sequence !== requestSequence) return;
      content.append(section);
      for (const source of scripts) {
        if (source.type && !['text/javascript', 'application/javascript', 'module'].includes(source.type)) {
          section.append(source);
          continue;
        }
        if (source.src && [...document.scripts].some(script => script.src === source.src)) continue;
        const script = document.createElement('script');
        if (source.src) {
          const sourceUrl = new URL(source.src, location.href);
          if (sourceUrl.origin !== location.origin) continue;
          script.src = sourceUrl.href;
          script.defer = true;
        } else script.textContent = source.textContent;
        section.append(script);
      }
      if (!quizCache.has(url.pathname)) {
        new MutationObserver(() => {
          content.scrollTo({ top: 0, behavior: 'instant' });
        }).observe(section, { subtree: true, attributes: true, attributeFilter: ['hidden'] });
        quizCache.set(url.pathname, section);
      }
      content.scrollTop = 0;
      status.hidden = true;
    } catch (error) {
      if (sequence !== requestSequence) return;
      const link = document.createElement('a');
      link.href = url.href;
      link.dataset.primaQuizFallback = '';
      link.textContent = dialog.querySelector('#prima-quiz-title').textContent;
      status.replaceChildren(link);
    } finally {
      if (sequence === requestSequence) content.removeAttribute('aria-busy');
    }
  };
  if (dialog && typeof dialog.showModal === 'function') {
    const connection = navigator.connection;
    const allowPreload = !connection?.saveData && !/^(slow-)?2g$/.test(connection?.effectiveType || '') && !window.Shopify?.designMode;
    if (allowPreload) {
      const warmLink = event => {
        const url = quizUrl(event.target.closest('a[href]'));
        if (url) fetchQuiz(url).catch(() => {});
      };
      document.addEventListener('pointerover', warmLink, { passive: true });
      document.addEventListener('focusin', warmLink);
    }
    document.addEventListener('click', event => {
      const link = event.target.closest('a[href]');
      if (!link || link.hasAttribute('data-prima-quiz-fallback') || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || link.target === '_blank') return;
      const url = quizUrl(link);
      if (!url) return;
      event.preventDefault();
      trigger = link;
      const title = url.pathname.includes('mattress-quiz') ? dialog.dataset.mattressTitle : dialog.dataset.scentTitle;
      dialog.querySelector('#prima-quiz-title').textContent = title;
      dialog.showModal();
      syncScrollLock();
      dialog.querySelector('[data-prima-quiz-close]').focus();
      loadQuiz(url);
    });
    dialog.querySelector('[data-prima-quiz-close]').addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', event => {
      if (event.target !== dialog) return;
      const rect = dialog.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
    });
    dialog.addEventListener('close', () => {
      syncScrollLock();
      trigger?.focus({ preventScroll: true });
    });
  }

  const normalizeText = value => value
    .replace(/máy khuếch tán bằng sậy/giu, 'Tinh Dầu Khuếch Tán')
    .replace(/nước hoa xịt phòng|xịt thơm phòng|xịt phòng/giu, 'Xịt Hương Phòng');
  const normalizeNode = node => {
    if (node.nodeType === Node.TEXT_NODE) {
      if (!node.parentElement?.closest('script,style,textarea,code,[contenteditable]')) {
        const next = normalizeText(node.nodeValue);
        if (next !== node.nodeValue) node.nodeValue = next;
      }
      return;
    }
    if (node.nodeType !== Node.ELEMENT_NODE || node.matches('script,style,textarea,code,[contenteditable]')) return;
    const walker = document.createTreeWalker(node, NodeFilter.SHOW_TEXT);
    let text;
    while ((text = walker.nextNode())) normalizeNode(text);
    for (const element of [node, ...node.querySelectorAll('[aria-label],[title],[alt]')]) {
      for (const attribute of ['aria-label', 'title', 'alt']) {
        const value = element.getAttribute(attribute);
        if (value && normalizeText(value) !== value) element.setAttribute(attribute, normalizeText(value));
      }
    }
  };
  normalizeNode(document.body);
  new MutationObserver(records => {
    for (const record of records) {
      if (record.type === 'characterData') normalizeNode(record.target);
      else record.addedNodes.forEach(normalizeNode);
    }
  }).observe(document.body, { childList: true, subtree: true, characterData: true });
})();
